import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareSearchParams } from '@/libs/helper';

const resource = `${Config.basePath}/report/satification`;

export default {
  chart(payload) {
    return Client.get(`${resource}`, {
      params: payload,
    });
  },
  index(payload) {
    return Client.get(`${resource}/channel`, {
      params: prepareSearchParams(payload),
    });
  },
  exportExcel(payload) {
    return Client.get(`${resource}/channel/export`, {
      params: payload,
      responseType: "blob",
    });
  },
};
